import { useContext } from 'react';
import { AnalyticsContext } from './analytics-provider';
export default function useAnalytics() {
  return useContext(AnalyticsContext);
}